import * as actionTypes from "../actions/types";
import _ from "underscore";

const initialState = {
  searchTerm: "", //process.env.NODE_ENV === "development" ? "גזים" : "",
  date: new Date(),
  allDates: false,
  aggregations: [],
  selectedAggregations: 0,
  relevantFiles: [],
  results: [],
  resultsFromServer: [],
  totalResults: 0,
  updateView: true,
  displaySpinner: false,
  displayByChapter: true
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_RELEVENT_FILES:
      const relevantFiles = getRelevantFiles(state, action.payload);
      return {
        ...state,
        relevantFiles: relevantFiles
      };
    case actionTypes.SELECT_AGGREGATION:
      const data = markAggregations(state, action.payload);
      return {
        ...state,
        aggregations: data.aggregations,
        selectedAggregations: data.selected
      };
    // return {
    //   ...state,
    //   orderedAggregations: orderAggregations(state)
    // };
    case actionTypes.SELECT_ALL_AGGREGATIONS:
      const aggregationsToMark = markAllAggregations(state, action.payload);
      return {
        ...state,
        aggregations: aggregationsToMark,
        selectedAggregations: action.payload ? aggregationsToMark.length : 0
      };
    // return {
    //   ...state,
    //   orderedAggregations: orderAggregations(state)
    // };
    case actionTypes.SET_SEARCH_RESULTS:
      const changeAggregations =
        !state.aggregations || state.aggregations.length === 0;
      return {
        ...state,
        resultsFromServer: action.payload.result.hits,
        results: setResultsOrder(
          state.displayByChapter,
          action.payload.result.hits
        ),
        searchTerm:
          action.payload.result.term !== state.searchTerm
            ? action.payload.result.term
            : state.searchTerm,
        totalResults:
          action.payload.result.total === 0 ? -1 : action.payload.result.total,
        aggregations: changeAggregations
          ? setAggregations(
              action.payload.result.aggregations,
              action.payload.allSpecifications
            )
          : state.aggregations,
        updateView: true
      };
    // return {
    //   ...state,
    //   orderedAggregations: orderAggregations(state)
    // };
    case actionTypes.SET_TERM:
      return {
        ...state,
        searchTerm: action.payload,
        updateView: false
      };
    case actionTypes.SET_DATE:
      return {
        ...state,
        date: action.payload.date,
        allDates: action.payload.allDates
      };
    case actionTypes.SET_ALL_DATES:
      return {
        ...state,
        allDates: action.payload.allDates,
        date: action.payload.date
      };
    case actionTypes.CLEAR_DATA:
      return {
        ...state,
        aggregations: [],
        relevantFiles: [],
        results: [],
        selectedAggregations: 0
      };
    case actionTypes.SET_DISPLAY_SPINNER:
      return {
        ...state,
        displaySpinner: action.payload
      };
    case actionTypes.DISPLAY_BY_CHAPTER:
      return {
        ...state,
        displayByChapter: action.payload,
        results: setResultsOrder(action.payload, state.resultsFromServer)
      };
    default:
      return state;
  }
}

const setResultsOrder = (displayByChapter, results) => {
  if (displayByChapter) {
    let orderedResultes = [];
    let detailedResults = _.map(results, result => {
      return {
        ...result,
        chapterIdentity: result.hit.chapterIdentity,
        docIdentity: result.hit.docIdentity
      };
    });
    let groupedByChapter = _.groupBy(detailedResults, "chapterIdentity");
    _.map(groupedByChapter, chapterResultes => {
      const sorted = _.sortBy(chapterResultes, "docIdentity");
      const groupedFiles = _.groupBy(sorted, "docIdentity");
      const orderedFilesOfChapter = [];
      _.map(groupedFiles, file => {
        const firstPageDetails = file[0].hit;
        orderedFilesOfChapter.push({
          docParentID: firstPageDetails.docParentID,
          publishAt: firstPageDetails.publishAt,
          docIdentity: firstPageDetails.docIdentity,
          pdfName: firstPageDetails.pdfName,
          pages: file
        });
      });
      orderedResultes.push({
        chapterName: chapterResultes[0].hit.chapterName,
        chapterIdForName: chapterResultes[0].hit.chapterIdForName,
        files: orderedFilesOfChapter
      });
      // orderedResultes.push({
      //   chapterName: chapterResultes[0].hit.chapterName,
      //   chapterIdForName: chapterResultes[0].hit.chapterIdForName,
      //   files: {
      //     docIdentity: files[0].hit.docIdentity,
      //     list: files
      //   }
      // });
    });
    return orderedResultes;
  } else {
    return results;
  }
};

const markAggregations = (state, data) => {
  let selected = state.selectedAggregations;
  let copy = Array.from(state.aggregations);
  let toChange = _.find(copy, agg => agg.id === data.id);
  if (toChange) {
    toChange.checked = data.isChecked;
    data.isChecked ? selected++ : selected--;
    if (toChange.chapterId === null) {
      //this is chapter change checked to new value
      let grouped = _.groupBy(copy, "chapterId");
      if (grouped[data.id]) {
        _.each(grouped[data.id], agg => {
          agg.checked = data.isChecked;
          data.isChecked ? selected++ : selected--;
        });
      }
    }
  }
  return { aggregations: copy, selected: selected };
};

const markAllAggregations = (state, isChecked) => {
  let copy = Array.from(state.aggregations);
  _.each(copy, agg => {
    agg.checked = isChecked;
  });
  return copy;
};

const getRelevantFiles = (state, allSpecifications) => {
  const publishedUntillDate = _.map(allSpecifications, chapter => {
    let chapterReleventEditions = _.filter(
      chapter.editions,
      element => new Date(element.publishAt) <= state.date
    );
    return {
      ...chapter,
      releventEditions: chapterReleventEditions
    };
  });
  const releventChapters = _.filter(publishedUntillDate, c => {
    return c.releventEditions.length > 0;
  });
  const releventEditions = _.map(releventChapters, function(chapter) {
    return chapter.releventEditions[0];
  });
  let releventDocIds = [];
  _.each(releventEditions, edition => {
    releventDocIds.push(edition.docIdentity);
    if (edition.fixes.length > 0) {
      _.each(edition.fixes, function(fix) {
        if (new Date(fix.publishAt) <= state.date) {
          releventDocIds.push(fix.docIdentity);
        }
      });
    }
  });
  return releventDocIds;
};

const setAggregations = (aggregations, allSpecifications) => {
  // const docs = _.map(aggregations.by_docRefiner.buckets, (doc, index) => {
  //   const splited = doc.key.split("~");
  //   return {
  //     aggregationText: doc.key,
  //     chapterId: splited[0],
  //     id: splited[1],
  //     name: splited[2],
  //     count: doc.doc_count,
  //     checked: false
  //   };
  // });
  const chapters = _.map(aggregations.by_chapterRefiner.buckets, chapter => {
    const splited = chapter.key.split("~");
    const name = _.findWhere(allSpecifications, { id: splited[0] })
      ? _.findWhere(allSpecifications, { id: splited[0] }).name
      : splited[1];
    return {
      aggregationText: chapter.key,
      chapterId: null,
      id: splited[0],
      name: name,
      count: chapter.doc_count,
      checked: false
    };
  });
  return chapters; //.concat(docs);
};

// const orderAggregations = state => {
//   const docs = _.filter(state.aggregations, agg => agg.chapterId !== null);
//   const docsGrouped = _.groupBy(docs, "chapterId");
//   const chapters = _.filter(state.aggregations, agg => agg.chapterId === null);
//   return _.map(chapters, chapter => {
//     const temp = {
//       ...chapter,
//       files: docsGrouped[chapter.id] ? docsGrouped[chapter.id] : []
//     };
//     return {
//       ...temp,
//       isOpen: setChapterIsOpenState(temp)
//     };
//   });
// };

// const setChapterIsOpenState = chapterAggregation => {
//   const checkedFiles = _.filter(
//     chapterAggregation.files,
//     file => file.checked === true
//   );
//   return chapterAggregation.checked || checkedFiles.length > 0;
// };
